import directives from './module';
import {AffiliateSvc} from '../services/AffiliateSvc';
import {Utils} from '../underscore-extensions';
import {removeHtmlClass} from './modalDialogDirective';

class AffiliatePopup {
    affModalShow: boolean;
    bigModalShown: boolean;
    affModalBottomShow: boolean;
    discount = 10;
    signupUrl = `/${Utils.getProduct().toLowerCase()}/signup`;
    canShow = true;

    private delayHandlerScroll = _.noop;

    constructor(private $rootScope: ng.IRootScopeService,
                private affiliateSvc: AffiliateSvc) {
        this.affiliateSvc.isTapAffiliate() && this.showPopups();

        this.$rootScope.$on('$stateChangeSuccess', (e, to) => {
            this.canShow = to.name !== 'wave-signup';
            this.closeBigPopup();
        });
    }

    closeBigPopup() {
        this.bigModalShown = true;
        this.affModalShow = false;
    }

    closeBottomPopup() {
        document.removeEventListener('scroll', this.delayHandlerScroll);
        this.affModalBottomShow = false;
    }

    private showPopups() {
        setTimeout(() => this.affModalShow = this.canShow, 5 * 1000);

        const handlerScroll = () => {
            const {scrollHeight, offsetHeight, scrollTop} = document.documentElement;

            const isBottom = scrollTop >= scrollHeight - offsetHeight;

            this.affModalBottomShow = isBottom && this.bigModalShown && this.canShow;

            if (!this.affModalBottomShow) {
                removeHtmlClass();
            }
        };

        this.delayHandlerScroll = _.debounce(handlerScroll, 50);

        document.addEventListener('scroll', this.delayHandlerScroll);
    }
}

directives.component('affiliatePopup', {
        controller: AffiliatePopup,
        templateUrl: require('affiliate-popup.html')
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/affiliatePopup.ts